import React from "react"
import { Form, Row, Col } from "react-bootstrap"
// import Select from "react-select";
import Creatable from "react-select/creatable"
import InputError from "../../InputError/InputError"

import "./Forms.css"
import { InfoCircleOutlined } from "@ant-design/icons"

function CreateSelectField({
  required,
  type,
  formLabel,
  size,
  options,
  searchable,
  name,
  value,
  onChange,
  isError,
  errorMessage = "",
  className,
  disabled,
  isMessage,
  onKeyDown,
  onInputChange
}) {
 
  return (
    <Form onSubmit={(e) => e.preventDefault()}>
      {type === "inline" ? (
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Row>
            <Col sm={4}>
              <Form.Label className="form-label align-left">
                {formLabel}
                {required && <span className="badge">*</span>}
              </Form.Label>
            </Col>
            <Col sm={6}>
              <Creatable
                options={options}
                value={value}
                onChange={(text) => onChange(text)}
                isDisabled={disabled}
                onKeyDown={onKeyDown}
                onInputChange={onInputChange}
              />
              <small className="badge-blue badge-for-mobilescreen" style={{ fontSize: 10 }}>
                <InfoCircleOutlined /> Can't find what you're looking for? Type
                anything to create a new option.
              </small>
              <InputError
                isValid={isError}
                message={errorMessage !== "" ? errorMessage : "*Required"}
              />
            </Col>
          </Row>
        </Form.Group>
      ) : (
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label className="align-left form-label">
            {formLabel}
            {required && <span className="badge">*</span>}
          </Form.Label>
          <Creatable
            options={options}
            value={value}
            onChange={(text) => onChange(text)}
            isDisabled={disabled}
            onKeyDown={onKeyDown}
            onInputChange={onInputChange}
          />
         {
            !isMessage && (
              <small className="badge-blue" style={{ fontSize: 10 }}>
                <InfoCircleOutlined /> Can't find the option you're looking for?
                Type anything to create a new option.
              </small>
            )
         }
          <InputError
            isValid={isError}
            message={errorMessage !== "" ? errorMessage : "*Required"}
          />
        </Form.Group>
      )}
    </Form>
  )
}

export default CreateSelectField
